import Login from "../Components/Login";
import "../CSS/LoginPage.css"


function LoginPage() {
    return (
        <div className="loginPage">
            <Login />
        </div>
    )
}

export default LoginPage;